// ECS-429: Omens no longer sells sexual-health accessories.
export const DISCONTINUED_SEX_SHOP_VARIANT_IDS = [491, 492, 493, 494, 1215] as const

export const isDiscontinuedSexShopVariant = (variantId: number): boolean =>
  DISCONTINUED_SEX_SHOP_VARIANT_IDS.some((discontinuedId) => discontinuedId === variantId)

export const filterDiscontinuedSexShopVariants = <T extends { variantId: number }>(items: T[]): T[] =>
  items.filter(({ variantId }) => !isDiscontinuedSexShopVariant(variantId))
